import React from 'react'

const EmployeesPlatformIcon = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='20' height='20' rx='10' fill='url(#paint0_linear_25038_36793)' />
    <path
      opacity='0.2'
      d='M10.0122 12.9922C11.6691 12.9922 13.0122 11.649 13.0122 9.99219C13.0122 8.33533 11.6691 6.99219 10.0122 6.99219C8.35535 6.99219 7.01221 8.33533 7.01221 9.99219C7.01221 11.649 8.35535 12.9922 10.0122 12.9922Z'
      fill='white'
    />
    <path d='M10.0122 9.99219L17.0122 2.99219' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M14.9571 5.03756C13.7159 3.79881 12.0549 3.07104 10.3029 2.99823C8.55078 2.92542 6.83519 3.51287 5.4955 4.64437C4.1558 5.77587 3.28959 7.36898 3.06822 9.10854C2.84686 10.8481 3.28647 12.6074 4.30009 14.0384C5.31371 15.4693 6.8275 16.4677 8.54197 16.836C10.2564 17.2043 12.0467 16.9157 13.5586 16.0273C15.0705 15.1389 16.1938 13.7154 16.7064 12.0384C17.2191 10.3614 17.0836 8.5531 16.3268 6.97122'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.1335 7.87082C11.6375 7.37485 10.9834 7.06836 10.2849 7.00461C9.58635 6.94086 8.88758 7.12388 8.31 7.52187C7.73243 7.91985 7.31256 8.50764 7.12338 9.18307C6.9342 9.85849 6.98767 10.5789 7.2745 11.2189C7.56132 11.859 8.06337 12.3784 8.69338 12.6868C9.32338 12.9951 10.0415 13.073 10.723 12.9068C11.4044 12.7406 12.0061 12.3409 12.4234 11.7771C12.8408 11.2134 13.0474 10.5212 13.0073 9.82092'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient id='paint0_linear_25038_36793' x1='0' y1='10' x2='20' y2='10' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#0246F8' />
        <stop offset='1' stopColor='#012B98' />
      </linearGradient>
    </defs>
  </svg>
)

export default EmployeesPlatformIcon
